// The only place where the PHP backend address is defined.
// This used to be hardcoded in 16 files, and inconsistently
// (http://127.0.0.1 in 14 places, http://localhost in 2 places - for the browser
// those are two different origins, so those calls could silently fail because of CORS).
//
// Changed through .env (REACT_APP_API_URL), without touching the code. See .env.example.
// Empty string by default - requests go to relative paths (e.g. "/login.php"),
// which the CRA dev server (e.g. via the "proxy" field in package.json) silently forwards to
// the real PHP server. This avoids the cross-origin/SameSite problem with the session
// cookie, which is not solved by CORS headers (a different browser mechanism).
// Set REACT_APP_API_URL in .env ONLY if you intentionally do not use the proxy.
export const API_BASE_URL = process.env.REACT_APP_API_URL ?? "";

/**
 * fetch() with the API_BASE_URL prefix. Throws an error if the server does not return an OK status,
 * instead of silently continuing with a faulty response.
 */
export async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    credentials: "include", // sends the PHP session cookie - without it $_SESSION is empty on every following call
    ...options,
  });
  if (!res.ok) {
    throw new Error(`Server greška: ${res.status}`);
  }
  return res;
}

/**
 * The backend sometimes returns a bare array and sometimes wraps it in {success, data: [...]}
 * (the same pattern as login.php/choose_db.php/select_db.php). This function
 * accepts both shapes and always returns a plain array, instead of the component
 * crashing on data.map() when a wrapped response arrives.
 */
export function unwrapArray(raw, key = "data") {
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.[key])) return raw[key];
  if (raw && raw.success === false) {
    console.warn("API je vratio grešku:", raw.error || raw);
  }
  return [];
}
